import { render, staticRenderFns } from "./HotLine.vue?vue&type=template&id=18e58a96&"
import script from "./HotLine.vue?vue&type=script&lang=js&"
export * from "./HotLine.vue?vue&type=script&lang=js&"
import style0 from "./HotLine.vue?vue&type=style&index=0&id=18e58a96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports